var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.contactInfoData, function (item, index) {
      return _c(
        "div",
        { key: item.id, staticClass: "sale-area-container" },
        [
          _c("ContactInfoItem", {
            ref: item.id,
            refInFor: true,
            staticClass: "sale-area-item",
            attrs: {
              fieldDisabled: _vm.disabled,
              contactInfoData: item,
              index: index,
            },
          }),
          !_vm.disabled && index > 0
            ? _c("el-button", {
                staticClass: "del-btn",
                attrs: { type: "text", icon: "el-icon-delete" },
                on: {
                  click: function ($event) {
                    return _vm.del(index)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }